<template>
  <div id="app" :style="activePalette">

    <!-- Navigation Layer -->
      <transition name="nav-backdrop-fade">
        <div id="navBackdrop" v-show="navIsOpen" v-on:click="toggleNav"></div>
      </transition>
      <transition name="nav-slide">
        <SlideoverNav v-if="isMobile" v-show="navIsOpen" />
      </transition>
      <transition name="header-switch">
        <HeaderCompDesktop v-if="isDesktop" />
      </transition>
      <transition name="header-switch">
        <HeaderCompMobile v-if="isMobile" />
      </transition>
    
    <!-- Main Content Layer -->
    <div id="bodyLayer">
      <div ref="homeSection" class="observerDiv" id="Home">  
        <HomeSection />
      </div>
      <div ref="aboutSection" class="observerDiv" id="About">
        <AboutSection />
      </div>
      <div ref="servicesSection" class="observerDiv" id="Services">
        <ServicesSection />
      </div>
      <div ref="partnersSection" class="observerDiv" id="Partners">
        <PartnersSection />
      </div>
      <div ref="contactSection" class="observerDiv" id="Contact">
        <ContactSection />
      </div>
    </div>
    <!-- <div id="ghettoConsole">
      Active Sections<br><br>
      Home: {{activeSections.home}}<br>
      About: {{activeSections.about}}<br>
      Services: {{activeSections.services}}<br>
      Partners: {{activeSections.partners}}<br>
      Contact: {{activeSections.contact}}<br>
    </div> -->
  </div>
</template>

<script>

import HeaderCompDesktop from './components/nav/HeaderCompDesktop.vue'
import HeaderCompMobile from './components/nav/HeaderCompMobile.vue'
import SlideoverNav from './components/nav/SlideoverNav.vue'

import HomeSection from './components/sections/Home.vue'
import AboutSection from './components/sections/About.vue'
import ServicesSection from './components/sections/Services.vue'
import PartnersSection from './components/sections/Partners.vue'
import ContactSection from './components/sections/Contact.vue'

export default {
  name: 'App',

  components: {
    HeaderCompDesktop,
    HeaderCompMobile,
    SlideoverNav,
    HomeSection,
    AboutSection,
    ServicesSection,
    PartnersSection,
    ContactSection
  },

  data() {
    return {
      colorPalette: { // Global CSS Varaibles for theme
        light: {
          '--body-bg-color': 'rgb(255, 255, 255)',
          '--bg-main' : 'rgb(237,235,242)',
          '--body-text': 'rgba(0, 0, 0, 1)',
          '--nav-backdrop-bg': 'rgba(11,7,22,.3)',
          '--nav-grad-pos': '0% 0%',
          '--logo-text': 'rgba(10, 10, 10, 1',
          '--nav-link': 'rgba(0, 0, 0, .6)',
          '--nav-link-hover': 'rgba(0, 0, 0, 1)',
          '--nav-highlight': 'rgba(103, 35, 184, .9)',
          '--hamburger-color': 'rgba(0, 0, 0, .8)',
          '--hamburger-active': 'rgb(101, 0, 224)'
        },
        dark: {
          '--body-bg-color': 'rgb(255, 255, 255)',
          '--bg-main' : 'rgb(22, 18, 32)',
          '--body-text': 'rgba(255, 255, 255, 255)',
          '--nav-backdrop-bg': 'rgba(210,150,250,.08)',
          '--nav-grad-pos': '0% 100%',
          '--logo-text': 'rgba(225, 225, 225, 1',
          '--nav-link': 'rgba(255, 255, 255, .75)',
          '--nav-link-hover': 'rgba(255, 255, 255, 1)',
          '--nav-highlight': 'rgba(168, 59, 246, .9)',
          '--hamburger-color': 'rgba(225, 225, 225, .9)',
          '--hamburger-active': 'rgb(143, 0, 232)'
        }
      },
      scrollPos: null,
      sectionElements: {
        home: null,
        about: null,
        services: null,
        partners: null,
        contact: null
      }
    }
  },

  computed: {
    activePalette() {
      if (this.$store.state.settings.darkModeOn) {
        return this.colorPalette.dark;
      } else {
        return this.colorPalette.light;
      }
    },
    darkModeOn() {
      return this.$store.state.settings.darkModeOn;
    },
    isMobile() {
      return this.$store.state.platform.isMobile;
    },
    isDesktop() {
      return this.$store.state.platform.isDesktop;
    },
    navIsOpen() {
      return this.$store.state.nav.isOpen;
    },
    activeSections() {
      return this.$store.state.activeSections;
    },
    darkZonesActive() {
      if (this.$store.state.activeSections.services || this.$store.state.activeSections.contact) {
        return true;
      } return false;
    }
  },

  mounted() {
    
    let self = this;
    
    // For conditional rendering of mobile or desktop navigation
    window.addEventListener('resize', self.throttle(function() {
      self.adaptPlatform();
    }, 150));
    
    this.adaptPlatform();
    
    // Define sections and push to state
    
    let sections = [
      { name: 'Home', el: this.$refs.homeSection },
      { name: 'About', el: this.$refs.aboutSection },
      { name: 'Services', el: this.$refs.servicesSection },
      { name: 'Partners', el: this.$refs.partnersSection },
      { name: 'Contact', el: this.$refs.contactSection }
    ];
    
    this.$store.commit('loadSections', sections);
    
    //Observer-related code for scroll event detection - uses sections variable
    
    function logIntersect(entries) { // Entries array is taken from IntersectionObserver
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          sections.forEach(section => {
            if (section.el === entry.target) {
              let sectionDetails = {name: section.name, isActive: true};
              self.$store.commit('toggleActiveSection', sectionDetails);
            }
            return;
          });
        } else {
          sections.forEach(section => {
            if (section.el === entry.target) {
              let sectionDetails = {name: section.name, isActive: false};
              self.$store.commit('toggleActiveSection', sectionDetails);
            }
            return;
          });
        }
      });
    }

    let root = this.$refs.observerRoot;
    
    let observerOptions = {
      root: root,
      rootMargin: '-50% 0% -50% 0%',
      threshold: 0
    };

    let sectionObserver = new IntersectionObserver(logIntersect, observerOptions);

    sections.forEach(section => {
      sectionObserver.observe(section.el);
    });

  },

  watch: {
    darkZonesActive() {
      if (this.darkZonesActive) {
        this.$store.commit('setDark', true);
      } else {
        this.$store.commit('setDark', false);
      }
    }

  },

  methods: {
    
    throttle(callback, interval) {
      let enableCall = true;
    
      return function(...args) {
        if (!enableCall) return;
    
        enableCall = false;
        callback.apply(this, args);
        setTimeout(() => enableCall = true, interval);
      }
    },
    
    adaptPlatform() {
      if (window.innerWidth <= 800 && this.$store.state.platform.name != 'mobile') {
        this.$store.commit('tellPlatform', 'mobile');
      } else if (window.innerWidth > 800 && this.$store.state.platform.name != 'desktop') {
        this.$store.commit('tellPlatform', 'desktop');
      }
    },
    
    toggleNav() {
      this.$store.commit('toggleNav');
    }
  }
}
</script>

<style>

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--body-text);
  border: solid red 0px;
  width: 100%;
  min-height: 100vh;
  max-width: 100vw;
  min-width: 320px;
  min-height: 100vh;
  overflow-x: hidden;
}

#intersectRoot {
  background-color: rgba(255, 0, 0, .2);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 500;
}

.observerDiv {
  width: 100%;
  border: dotted red 0px;
}

#bodyLayer {
  position: relative;
  width: 100%;
  min-height: 100vh;
  z-index: 0;
  border: solid red 0px;
}

#navBackdrop {
  width: 100%;
  height: 100%;
  background-color: var(--nav-backdrop-bg);
  position: fixed;
  z-index: 50;
  border: solid blue 0px;
  transition-duration: 400ms;
}

#ghettoConsole {
  background-color: var(--bg-main);
  color: var(--body-text);
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  left: 50%;
  top: 80%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  z-index: 300;
}

/* Vue Transitions */

.header-switch-enter-active .header-switch-leave-active {
  transition: transform 350ms cubic-bezier(.47,0,.2,1);
  transition-delay: 350ms;
}

.header-switch-enter, .header-switch-leave-to {
  transform: translateY(-120px);
  opacity: 0;
}

.nav-slide-enter-active, .nav-slide-leave-active {
  transition: transform 400ms cubic-bezier(.47,0,.32,1);
}

.nav-slide-enter, .nav-slide-leave-to {
  transform: translateX(-300px);
}

.nav-backdrop-fade-enter-active, .nav-backdrop-fade-leave-active {
  transition: all 300ms cubic-bezier(.47,0,.2,1);
}

.nav-backdrop-fade-enter, .nav-backdrop-fade-leave-to {
  opacity: 0;
}

</style>
